import React from "react";
import "./Placements.css";
import Somil from "../assets/Somil.jpeg";
import Raj from "../assets/Raj.jpeg";
import Vikas from "../assets/Vikas.jpeg"
import Shubham from "../assets/Shubham.jpeg";
import Ritik from "../assets/Ritik.jpeg";
import Naman from "../assets/Naman.jpg";

const students = [
  {
    name: "Somil Sonbhurra",
    company: "Codesutra ai",
    course: "Full Stack Developer",
    package: "3.2 LPA",
    photo: Somil,
  },
  {
    name: "Raghvendra Kushwah",
    company: "Impetus",
    course: "AIML Blockchain",
    package: "8 LPA",
    photo: Raj
  },
  {
    name: "Vikas Yadav",
    company: "Walkover Web Solutions",
    course: "Python Developer",
    package: "3.5 LPA",
    photo: Vikas,
  },
  {
    name: "Shubham Kushwah",
    company: "Arihant Capital",
    course: "Data Analyst",
    package: "5 LPA",
    photo: Shubham,
  },
  {
    name: "Hrithik Kaul",
    company: "TaskUs",
    course: "Process Analyst",
    package: "4.5 LPA",
    photo: Ritik,
  },
  {
    name: "Naman Jain",
    company: "Bannet and Bernard",
    course: "Business Analyst",
    package: "11 LPA",
    photo: Naman,
  },
];

const Placements = () => {
  return (
    <section className="placements-section">
      <div className="placements-header">
        <h2>
          Our Students Are <br /> <span>Getting Placed!</span>
        </h2>
        <p>
          Codex Future has successfully trained and placed hundreds of students
          in top IT companies across India. Start your journey with us today!
        </p>
      </div>

      <div className="placements-marquee">
        <div className="marquee-inner">
          {[...students, ...students].map((student, index) => (
            <div key={index} className="placement-card">

              <div className="top-row">
                <img
                  src={student.photo}
                  alt={student.name}
                  className="student-photo"
                />
                <h3 className="student-name">{student.name}</h3>
              </div>

              <p className="role-full">{student.course}</p>

              <p className="company">
                Placed at <strong>{student.company}</strong>
              </p>

              {/* ⭐ NEW PACKAGE LINE ⭐ */}
              <p className="package">Package: <strong>{student.package}</strong></p>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Placements;
